import Guard from '../../services/Middleware'

export default [
  {
    path: '/Onibus',
    name:'Viagens Onibus',
    component: () => import('@/views/onibus/index.vue'),
    beforeEnter: Guard.auth
  },  
  {
    path: '/Onibus/Licenca',
    name:'Licencas Onibus',
    component: () => import('@/views/onibus/indexLicencas.vue'),
    beforeEnter: Guard.auth
  }, 
  {
    path: '/Onibus/Combustiveis',
    name:'Combustiveis Onibus',
    component: () => import('@/views/onibus/indexCombustiveis.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Onibus/Viagem/Adicionar',
    name:'Adicionar Viagem Onibus',
    component: () => import('@/views/onibus/addViagemOnibus.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Onibus/Editar_Viagem/:id',
    name:'Editar Viagem Onibus',
    component: () => import('@/views/onibus/addViagemOnibus.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Onibus/Passageiros/:id',
    name:'Passageiros Viagem',
    component: () => import('@/views/onibus/indexPassageiros.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Onibus/Despesas/:id',
    name:'Despesas Viagem',
    component: () => import('@/views/onibus/indexDespesas.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Onibus/Relatorio',
    name:'Relatorio Viagens Onibus',
    component: () => import('@/views/onibus/relatorioViagem.vue'),
    beforeEnter: Guard.auth
  },
]